import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { trackAppEvent } from '@/lib/analytics/track';

/** Une page vue par changement de route (compteur maison, migration 0523). */
export function PageViewTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => {
    // rendu des vidéos par le worker (`/capture/…`) : pas une visite
    if (pathname.startsWith('/capture/')) return;
    trackAppEvent('page_view', pathname);
  }, [pathname]);
  return null;
}
